import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "contentcardschemadata"
    }}>{`ContentCardSchemaData`}</h1>
    <p>{`Represents the proposition response object containing a `}<inlineCode parentName="p">{`content-card`}</inlineCode>{` schema.`}</p>
    <h2 {...{
      "id": "ios-interface"
    }}>{`iOS Interface`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`@objc(AEPContentCardSchemaData)
@objcMembers
public class ContentCardSchemaData: NSObject, Codable {
    /// Represents the content of the ContentCardSchemaData object.  Its value's type is determined by \`contentType\`.
    public let content: Any
    
    /// Determines the value type of \`content\`.
    public let contentType: ContentType
    
    /// Date and time this content card was published represented as epoch seconds
    public let publishedDate: Int?
    
    /// Date and time this content card will expire represented as epoch seconds
    public let expiryDate: Int?
    
    /// Dictionary containing any additional meta data for this content card
    public let meta: [String: Any]?

    ...
}
`}</code></pre>
    <h3 {...{
      "id": "public-functions"
    }}>{`Public functions`}</h3>
    <hr></hr>
    <h3 {...{
      "id": "getcontentcard---deprecated"
    }}>{`getContentCard - DEPRECATED`}</h3>
    <InlineAlert variant="warning" slots="header, text" mdxType="InlineAlert" />
    <p>{`Notice of deprecation`}</p>
    <p><inlineCode parentName="p">{`ContentCard`}</inlineCode>{` class is deprecated as of `}<inlineCode parentName="p">{`v5.2.0`}</inlineCode>{` (iOS) and will be removed in the next major release of the Messaging extension.`}</p>
    <p>{`Tries to convert the `}<inlineCode parentName="p">{`content`}</inlineCode>{` of this `}<inlineCode parentName="p">{`ContentCardSchemaData`}</inlineCode>{` into a `}<a parentName="p" {...{
        "href": "./content-card.md"
      }}><inlineCode parentName="a">{`ContentCard`}</inlineCode></a>{` object.`}</p>
    <p>{`Returns `}<inlineCode parentName="p">{`nil`}</inlineCode>{` if the `}<inlineCode parentName="p">{`contentType`}</inlineCode>{` is not equal to `}<inlineCode parentName="p">{`.applicationJson`}</inlineCode>{` or the data in `}<inlineCode parentName="p">{`content`}</inlineCode>{` is not decodable into a `}<inlineCode parentName="p">{`ContentCard`}</inlineCode>{`.`}</p>
    <h4 {...{
      "id": "syntax"
    }}>{`Syntax`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`func getContentCard() -> ContentCard?
`}</code></pre>
    <h4 {...{
      "id": "example"
    }}>{`Example`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`var propositionItem: PropositionItem
if let contentCardSchemaData = propositionItem.contentCardSchemaData,
   let contentCard = contentCardSchemaData.getContentCard() {
    // do something with the ContentCard object
}
`}</code></pre>
    <h3 {...{
      "id": "track_withedgeeventtype"
    }}>{`track(_:withEdgeEventType:)`}</h3>
    <p>{`Tracks an interaction with the given `}<inlineCode parentName="p">{`ContentCardSchemaData`}</inlineCode>{`.`}</p>
    <h4 {...{
      "id": "syntax-1"
    }}>{`Syntax`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`public func track(_ interaction: String? = nil, withEdgeEventType eventType: MessagingEdgeEventType)
`}</code></pre>
    <h4 {...{
      "id": "parameters"
    }}>{`Parameters`}</h4>
    <ul>
      <li parentName="ul"><em parentName="li">{`interaction`}</em>{` - a custom `}<inlineCode parentName="li">{`String`}</inlineCode>{` value to be recorded in the interaction`}</li>
      <li parentName="ul"><em parentName="li">{`eventType`}</em>{` - the `}<a parentName="li" {...{
          "href": "./messaging-edge-event-type.md"
        }}><inlineCode parentName="a">{`MessagingEdgeEventType`}</inlineCode></a>{` to be used for the ensuing Edge Event`}</li>
    </ul>
    <h4 {...{
      "id": "example-1"
    }}>{`Example`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`var contentCardSchemaData: ContentCardSchemaData

// tracking a display
contentCardSchemaData.track(withEdgeEventType: .display)

// tracking a user interaction
contentCardSchemaData.track("itemSelected", withEdgeEventType: .interact)
`}</code></pre>
    <h2 {...{
      "id": "android-interface"
    }}>{`Android Interface`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`public class ContentCardSchemaData implements SchemaData {
    private Object content;
    private ContentType contentType;
    private int publishedDate;
    private int expiryDate;
    private Map<String, Object> meta;

    @Override
    public Object getContent() {
        return content;
    }

    public ContentType getContentType() {
        return contentType;
    }

    public int getPublishedDate() {
        return publishedDate;
    }

    public int getExpiryDate() {
        return expiryDate;
    }

    @Nullable public Map<String, Object> getMeta() {
        return meta;
    }

    ...
}
`}</code></pre>
    <h3 {...{
      "id": "public-functions-1"
    }}>{`Public functions`}</h3>
    <hr></hr>
    <h3 {...{
      "id": "getcontentcard---deprecated-1"
    }}>{`getContentCard - DEPRECATED`}</h3>
    <InlineAlert variant="warning" slots="header, text" mdxType="InlineAlert" />
    <p>{`Notice of deprecation`}</p>
    <p><inlineCode parentName="p">{`ContentCard`}</inlineCode>{` class is deprecated as of `}<inlineCode parentName="p">{`v3.2.0`}</inlineCode>{` (Android) and will be removed in the next major release of the Messaging extension.`}</p>
    <p>{`Tries to convert the `}<inlineCode parentName="p">{`content`}</inlineCode>{` of this `}<inlineCode parentName="p">{`ContentCardSchemaData`}</inlineCode>{` into a `}<a parentName="p" {...{
        "href": "./content-card.md"
      }}><inlineCode parentName="a">{`ContentCard`}</inlineCode></a>{` object.`}</p>
    <p>{`Returns `}<inlineCode parentName="p">{`null`}</inlineCode>{` if the `}<inlineCode parentName="p">{`contentType`}</inlineCode>{` is not equal to `}<inlineCode parentName="p">{`ContentType.APPLICATION_JSON`}</inlineCode>{` or the data in `}<inlineCode parentName="p">{`content`}</inlineCode>{` is not decodable into a `}<inlineCode parentName="p">{`ContentCard`}</inlineCode>{`.`}</p>
    <h4 {...{
      "id": "syntax-2"
    }}>{`Syntax`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`@Nullable public ContentCard getContentCard();
`}</code></pre>
    <h4 {...{
      "id": "example-2"
    }}>{`Example`}</h4>
    <h4 {...{
      "id": "kotlin"
    }}>{`Kotlin`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-kotlin"
      }}>{`val propisitionItem: PropositionItem
val contentCardData = item?.contentCardSchemaData
val contentCard = contentCardData?.contentCard
contentCard?.let {
  // do something with the ContentCard object
}
`}</code></pre>
    <h4 {...{
      "id": "java"
    }}>{`Java`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`PropositionItem propositionItem;
ContentCardSchemaData contentCardSchemaData = propositionItem.getContentCardSchemaData();
ContentCard contentCard = contentCardSchemaData.getContentCard();
if (contentCard != null) {
  // do something with the ContentCard object
}
`}</code></pre>
    <h3 {...{
      "id": "track"
    }}>{`track`}</h3>
    <p>{`Tracks an interaction with the given `}<inlineCode parentName="p">{`ContentCardSchemaData`}</inlineCode>{`.`}</p>
    <h4 {...{
      "id": "syntax-3"
    }}>{`Syntax`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`public void track(final String interaction, final MessagingEdgeEventType eventType);
`}</code></pre>
    <h4 {...{
      "id": "parameters-1"
    }}>{`Parameters`}</h4>
    <ul>
      <li parentName="ul"><em parentName="li">{`interaction`}</em>{` - a custom `}<inlineCode parentName="li">{`String`}</inlineCode>{` value to be recorded in the interaction`}</li>
      <li parentName="ul"><em parentName="li">{`eventType`}</em>{` - the `}<a parentName="li" {...{
          "href": "./messaging-edge-event-type.md"
        }}><inlineCode parentName="a">{`MessagingEdgeEventType`}</inlineCode></a>{` to be used for the ensuing Edge Event`}</li>
    </ul>
    <h4 {...{
      "id": "example-3"
    }}>{`Example`}</h4>
    <h4 {...{
      "id": "kotlin-1"
    }}>{`Kotlin`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-kotlin"
      }}>{`val contentCardSchemaData = item?.contentCardSchemaData

// tracking a display
contentCardSchemaData?.track(null, MessagingEdgeEventType.DISPLAY)

// tracking a user interaction
contentCardSchemaData?.track("itemSelected", MessagingEdgeEventType.INTERACT)
`}</code></pre>
    <h4 {...{
      "id": "java-1"
    }}>{`Java`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`ContentCardSchemaData contentCardSchemaData;

// tracking a display
contentCardSchemaData.track(null, MessagingEdgeEventType.DISPLAY);

// tracking a user interaction
contentCardSchemaData.track("itemSelected", MessagingEdgeEventType.INTERACT);
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      